import React, { FC, PropsWithChildren, useCallback, useState } from 'react';
import { TextTyper } from '@wix/chat-widget-ui-lib';
import { Box } from '@wix/design-system';
import { useScrollableChatElement } from '../../../../hooks/useScrollableChatElement';

export type MessageDisplayProps = PropsWithChildren<{
  message: string;
}>;

export const MessageDisplay: FC<MessageDisplayProps> = ({ children, message }) => {
  const [showChildren, setShowChildren] = useState(!message);
  const { scrollChatToBottom } = useScrollableChatElement();

  const onTypingEnd = useCallback(() => {
    setShowChildren(true);
  }, [setShowChildren]);

  return (
    <Box direction="vertical" gap="8px">
      {message && <TextTyper typingSpeed={5} text={message} onTypingEnd={onTypingEnd} onTyping={scrollChatToBottom} />}
      {children && (
        <Box direction="vertical" align="left" visibility={showChildren ? 'visible' : 'hidden'} width="100%">
          {children}
        </Box>
      )}
    </Box>
  );
};
